import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectAdvertising } from "../redux/selectors";
import {
  setSmartMenu,
  fetchAdvertising,
  updateAdvertising,
} from "../redux/actions";
import {
  delete_advertising,
  upload_advertising_banner,
} from "../utils/requestHelper";
import { useNavigate } from "react-router-dom";
import { Advertising } from "../components";

const Advertisement = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const advertising = useSelector(selectAdvertising);

  useEffect(() => {
    const { id } = params;
    if (id)
      dispatch(fetchAdvertising(id));
  }, [props]);

  useEffect(() => {
    if (advertising)
      dispatch(
        setSmartMenu({
          headline: `${advertising.title}`,
          buttons: [],
          navigation: null,
        }),
      );
  }, [advertising]);

  const handleOnClickDelete = async (target) => {
    const { id } = target;
    var result = await delete_advertising(id);
    if (result.success === true) {
      navigate(`/advertisings`);
    }
  };

  const handleOnClickCancel = async () => {
    navigate(`/advertisings`);
  };

  const handleOnClickSubmit = async (target) => {
    const { id, data } = target;
    dispatch(updateAdvertising(id, data));
    navigate(`/advertisings`);
  };

  const handleOnFileChange = async (target) => {
    const { id, e } = target;
    if (!e.target.files[0]) return;
    if (e.target.files[0].size > 5300000) {
      alert("File is too big!");
      return;
    }
    const response = await upload_advertising_banner(id, e.target.files[0]);
    if (response.success)
      dispatch(updateAdvertising(id, { imageUrl: response.fileUrl }));
  };
console.log(advertising);
  return (
    <article>
      <Advertising
        show={true}
        data={advertising}
        onClickDelete={handleOnClickDelete}
        onClickCancel={handleOnClickCancel}
        onClickSubmit={handleOnClickSubmit}
        onFileChange={handleOnFileChange}
      />
    </article>
  );
};

export default Advertisement;
